import React from 'react';
import styles from './header.module.css';
import Icon from '../../icons/icons';
import * as consts from "../../../store/constants/userInfo";
import {getInfoAction} from "../../../store/actions/getInfoAction";
import {connect} from "react-redux";

class Header extends React.Component {

  componentDidMount() {
    if (this.props.data.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "client/info", this, consts.CLIENT_INFO);
    this.props.fetchData(process.env.REACT_APP_GATE + "partner/properties", this, consts.PARTNER_PROPERTIES);
  }

  handleMenu = () => {
    var body = document.querySelector("body");
    body.classList.toggle('visible-menu')
  }

  showSettings = () => {
    let settingsMenu = document.querySelector("[data-menu='settings']");
    settingsMenu.click();
  }

  render () {
    return (
      <header className={styles.header}>
        {this.props.type === 'pubinner'?
          <div className="inner inner_small header__inner">
            <div className={styles.clear}>
              <div className={styles.logo} id="app-logo">{''}</div>
              <div className={styles.app}>Самозанятые</div>
              <a className={`${styles.username} ${styles.link}`} href={process.env.REACT_APP_ELF_URL + '?priv=true'}>
                <Icon name="icon_home" viewbox="0 0 24 24"/>
                Интернет банк
              </a>
            </div>
          </div>
          :
          <div className="inner header__inner">
            <div className={styles.clear}>
              <div className={styles.logo} id="app-logo">{''}</div>
              <div className={styles.app}>Самозанятые</div>
              {this.props.data.items?.data ?
                <div>
                  <div className={`${styles.username} ${styles.link} ${styles.menu}`} onClick={this.handleMenu}>
                    <Icon name="icon_menu" viewbox="0 0 24 24"/>
                  </div>
                  <div className={`${styles.username} ${styles.link}`} onClick={this.showSettings}>
                    <Icon name="icon_login" viewbox="0 0 24 24"/>
                    <span>{this.props.data.items.data.name} {this.props.data.items.data.surname}</span>
                  </div>
                </div>
                :
                <a className={`${styles.username} ${styles.link} ${styles.mobile_home}`} href={process.env.REACT_APP_ELF_URL + '?priv=true'}>
                  <Icon name="icon_home" viewbox="0 0 24 24"/>
                  <span>Интернет банк</span>
                </a>
              }
              <a className={`${styles.username} ${styles.link}`} href={process.env.REACT_APP_ELF_URL + '?priv=true'}>
                <Icon name="icon_home" viewbox="0 0 24 24"/>
                <span>Интернет банк</span>
              </a>
            </div>
          </div>
        }
      </header>
    )
  }
}

const mapStateToProps = state => ({data: state.clientInfo})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);